import { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Cinematic garnet intro: "where were you darling?" fades in, holds, then lifts away.
export default function Intro({ onFinish }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Lock scroll while the intro plays
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.scrollTo(0, 0);

    let revealed = false;
    const reveal = () => {
      if (revealed) return;
      revealed = true;
      setReady(true);
    };

    // Try to preload Sacred Letter once — cap the wait at 300ms so a slow font
    // never keeps the screen black.
    const fallback = setTimeout(reveal, 300);
    try {
      if (document.fonts && document.fonts.load) {
        document.fonts
          .load('700 96px "Sacred Letter"')
          .then(reveal)
          .catch(reveal);
      } else {
        reveal();
      }
    } catch {
      reveal();
    }

    // Auto-exit intro 3.2s after the text becomes visible.
    // We attach this once `ready` is toggled via a separate effect below.
    return () => {
      clearTimeout(fallback);
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    if (!ready) return;
    const t = setTimeout(() => onFinish(), 3200);
    return () => clearTimeout(t);
  }, [ready, onFinish]);

  return (
    <motion.div
      data-testid="intro-overlay"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, filter: "blur(8px)" }}
      transition={{ duration: 0.9, ease: [0.85, 0, 0.15, 1] }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0a0a0a] overflow-hidden"
    >
      {/* subtle vignette */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.45)_100%)]" />

      <div className="relative text-center px-6" style={{ visibility: ready ? "visible" : "hidden" }}>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={ready ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
          className="font-script text-white text-6xl sm:text-7xl md:text-8xl lg:text-9xl leading-[0.95]"
        >
          where were you darling?
        </motion.p>

        <motion.div
          initial={{ scaleX: 0 }}
          animate={ready ? { scaleX: 1 } : { scaleX: 0 }}
          transition={{ delay: 0.6, duration: 1.6, ease: [0.85, 0, 0.15, 1] }}
          className="h-px bg-white/50 mt-10 mx-auto w-40 origin-center"
        />

        <motion.span
          initial={{ opacity: 0 }}
          animate={ready ? { opacity: 1 } : { opacity: 0 }}
          transition={{ delay: 1.3, duration: 0.8 }}
          className="block mt-8 text-[10px] sm:text-xs uppercase tracking-[0.5em] font-bold text-white/60 font-body"
        >
          VogueVerve
        </motion.span>
      </div>
    </motion.div>
  );
}
